import { PaginatedRooms } from "@/models/room";
import { PaginatedRoom } from "@/models/room/room.list.model";
import { PaginatedRoomDTO, PaginatedRoomsDTO } from "../dtos";

export const mapPaginatedRoomsDTOtoPaginatedRooms = (
  paginatedRooms: PaginatedRoomsDTO["data"]
): PaginatedRooms => {
  return {
    rooms: paginatedRooms.rooms.map(mapPaginatedRoomDTOtoRoom),
    totalPages: paginatedRooms.totalPages,
    totalRooms: paginatedRooms.totalRooms,
  };
};

const mapPaginatedRoomDTOtoRoom = (room: PaginatedRoomDTO): PaginatedRoom => {
  return {
    _id: room._id,
    name: room.name,
    monitor: Boolean(room.monitor),
    nightAgent: room.nightAgent,
    batteryCapacity: room.batteryCapacity,
    address: room.address,
    address2: room.address2,
    zipCode: room.zipCode,
    city: room.city,
    province: room.province,
    country: room.country,
    username: room.username,
    smokingAlertThreshold: room.smokingAlertThreshold,
    crowdingAlertTreshold: room.crowdingAlertTreshold,
    noiseSettings: room.noiseSettings,
    devices: room.devices?.map((device) => ({
      ...device,
      alarms_enabled: device.alarms_enabled,
    })),
    devicesOnline: room.devicesOnline,
    devicesTotal: room.devicesTotal,
  };
};
